module.exports = __webpack_public_path__ + "img/no-image.ea3d77fa.svg";